import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))
const TaskDetail = lazy(() => import('./TaskDetail'))

//	///////////////////////
//	MARK: EXPORTS
// Fiches sous préfixe statique « file/ » : leurs onglets prennent le reste de l'URL (leçon S4).
export const MaintenanceProgrammeRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet']}>
    <Route path='file/:programmeId/task/:taskId/*' element={<TaskDetail />} />
    <Route path='file/:programmeId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
